export function formatSecond2Minute(seconds) {
    return [parseInt(seconds / 60 % 60),parseInt(seconds % 60)].join(':').replace(/\b(\d)\b/g, '0$1');
}

var PI = 3.1415926535897932384626;
var a = 6378245.0;
var ee = 0.00669342162296594323;

var transformlat = (lng, lat) => {
    var lat = +lat;
    var lng = +lng;
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
    return ret
};

var transformlng = (lng, lat) => {
    var lat = +lat;
    var lng = +lng;
    var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
    return ret
};

export function wgs84togcj02(lng, lat) {
    var lat = +lat;
    var lng = +lng;

    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = lat / 180.0 * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
    dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
    var mglat = lat + dlat;
    var mglng = lng + dlng;
    return [mglng, mglat];
  };

export function getDistance(lng1, lat1, lng2, lat2) {
    lat1 = +lat1 || 0;
    lng1 = +lng1 || 0;
    lat2 = +lat2 || 0;
    lng2 = +lng2 || 0;
    var rad1 = lat1 * Math.PI / 180.0;
    var rad2 = lat2 * Math.PI / 180.0;
    var a = rad1 - rad2;
    var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
    var r = 6378137;
    return r * 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(rad1) * Math.cos(rad2) * Math.pow(Math.sin(b / 2), 2)));
}

export function formatDistance(distance) {
    distance = + distance || 0;
    return distance ? (distance >= 1000 ? '距您' + parseInt(distance / 1000) + '公里' : '距您' + distance.toFixed(1) + '米') : '';
}
export function formatDistance2(distance) {
    distance = + distance || 0;
    return distance ? (distance >= 1000 ? parseInt(distance / 1000) + 'km' : distance.toFixed(1) + 'm') : '';
}

export function getAngle(lng_a, lat_a, lng_b, lat_b) {
    var a = (90 - lat_b) * Math.PI / 180;
    var b = (90 - lat_a) * Math.PI / 180;
    var AOC_BOC = (lng_b - lng_a) * Math.PI / 180;
    var cosc = Math.cos(a) * Math.cos(b) + Math.sin(a) * Math.sin(b) * Math.cos(AOC_BOC);
    var sinc = Math.sqrt(1 - cosc * cosc);
    var sinA = Math.sin(a) * Math.sin(AOC_BOC) / sinc;
    var A = Math.asin(sinA) * 180 / Math.PI;
    var res = 0;
    if (lng_b > lng_a && lat_b > lat_a) res = A;
    else if (lng_b > lng_a && lat_b < lat_a) res = 180 - A;
    else if (lng_b < lng_a && lat_b < lat_a) res = 180 - A;
    else if (lng_b < lng_a && lat_b > lat_a) res = 360 + A;
    else if (lng_b > lng_a && lat_b == lat_a) res = 90;
    else if (lng_b < lng_a && lat_b == lat_a) res = 270;
    else if (lng_b == lng_a && lat_b > lat_a) res = 0;
    else if (lng_b == lng_a && lat_b < lat_a) res = 180;
    return res;
};

export function os() {
    var ua = navigator.userAgent, 
        isWindowsPhone = /(?:Windows Phone)/.test(ua), 
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,  
        isAndroid = /(?:Android)/.test(ua),  
        isFireFox = /(?:Firefox)/.test(ua),  
        isChrome = /(?:Chrome|CriOS)/.test(ua), 
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)), 
        isPhone = /(?:iPhone)/.test(ua) && !isTablet, 
        isPc = !isPhone && !isAndroid && !isSymbian,
        isWx = ua.toLowerCase().match(/MicroMessenger/i)=="micromessenger",
        isPhoneWx = !isPc && isWx,
        isTTWebView = ua.toLowerCase().includes("toutiaomicroapp"),
        isAliApp = ua.indexOf("AliApp") !== -1,
        isQQApp = ua.indexOf("miniProgram") !== -1,
        isSmartApp = /swan\//.test(window.navigator.userAgent) || /^webswan-/.test(window.name);
    return { 
        isTablet: isTablet, 
        isPhone: isPhone, 
        isAndroid : isAndroid, 
        isPc : isPc,
        isWx: isWx,
        isPhoneWx: isPhoneWx,
        isTTWebView: isTTWebView,
        isAliApp: isAliApp,
        isQQApp: isQQApp,
        isSmartApp: isSmartApp,
    };
}


// WEBPACK FOOTER //
// ./src/utils/utils.js